export default {
  name: 'RowEmpty',
  props: {
    scheduleData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    departmentId: {
      type: Number
    },
    divisionId: {
      type: Number
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    currentSchedule () {
      for (const key in this.scheduleData.schedules) {
        if (
          this.scheduleData.schedules[key].department_id == this.departmentId &&
          this.scheduleData.schedules[key].division_id == this.divisionId &&
          this.scheduleData.schedules[key].type === this.type
        ) {
          return this.scheduleData.schedules[key];
        }
      }
      return null;
    }
  },
  methods: {
    addRecord: function (day) {
      if (!this.editable) return;

      const record = {
        id: null,
        user_id: null,
        department_id: this.departmentId,
        division_id: this.divisionId,
        shift_id: '',
        work_from_home: false,
        datetime_start: day.sql_day + ' 08:00',
        datetime_end: day.sql_day + ' 18:00',
        notes: '',
        type: this.type,
        schedule_id: (this.currentSchedule ? this.currentSchedule.id : null)
      };

      this.$emit('addRecord', record);
    }
  }
}
